import { useActivityContentQuery } from "./useActivityContentQuery";

export type UseActivityAssetsSourceQueryParams = {
  courseId: string;
  activityId: string;
  learnerId?: string;
  attempt?: number;
  enabled?: boolean;
};

export function useActivityAssetsSourceQuery({
  courseId,
  activityId,
  learnerId,
  attempt,
  enabled = true,
}: UseActivityAssetsSourceQueryParams) {
  const { data: activityContent } = useActivityContentQuery({
    courseId,
    activityId,
    learnerId,
    attempt,
    enabled,
  });

  return {
    activity: activityContent?.activity,
    assets: activityContent?.assets,
    contentVersion: activityContent?.contentVersion,
  };
}
